//Global Search
export const applySearch = (rows, searchText) => {
  if (!searchText || !searchText.trim()) {
    return rows;
  }

  const search = searchText.toLowerCase();
  return rows.filter((row) => Object.values(row).join(' ').toLowerCase().includes(search));
};

export const applyColumnSearch = (rows, columnSearch) => {
  const activeFilters = Object.entries(columnSearch)
    .filter(([, value]) => value?.trim())
    .map(([field, value]) => ({
      field,
      value: value.toLowerCase(),
    }));

  if (!activeFilters.length) {
    return rows;
  }

  return rows.filter((row) =>
    activeFilters.every(({ field, value }) =>
      String(row[field] ?? '')
        .toLowerCase()
        .includes(value)
    )
  );
};

//Client Mode Processor
export const processClientRows = ({ rows, searchText, columnSearch }) => {
  let result = applySearch(rows, searchText);

  result = applyColumnSearch(result, columnSearch);

  return result;
};
